var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('CarouselHome'),_c('NewsInfomation'),_c('TodoShow'),_c('NewFeatures'),_c('CoreCompetence')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }